import { cn } from '@/lib/utils'

import { useGoogleTranslateWidget } from './use-google-translate-widget'

export const GoogleTranslateWidget = () => {
  const { targetElementRef } = useGoogleTranslateWidget()

  return (
    <div className={cn('flex items-center gap-4')}>
      <div
        ref={(el) => {
          targetElementRef.current = el
        }}
        className={cn('hidden')}
      />
    </div>
  )
}
